import axios from 'axios'
const header = {
  'Content-Type': 'application/json'
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_ECS_ONOFF,
  headers: { ...header }
})